export default __webpack_public_path__ + "static/icon-6dca591e3658782c0d3e8dfc96c41b6e.png";